import Model, { attr } from '@ember-data/model';

export default abstract class AbstractStayStrategyModel extends Model {
  @attr('number') sunday!: number;
  @attr('number') monday!: number;
  @attr('number') tuesday!: number;
  @attr('number') wednesday!: number;
  @attr('number') thursday!: number;
  @attr('number') friday!: number;
  @attr('number') saturday!: number;
}
